import React from 'react';

const Dropdown = ({ icon, badgeCount, title, items, footerAction }) => {
  return (
    <li className="nav-item dropdown">
      <a className="nav-link nav-icon" href="#" data-bs-toggle="dropdown">
        <i className={`bi ${icon}`}></i>
        {badgeCount && <span className="badge bg-primary badge-number">{badgeCount}</span>}
      </a>
      <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow">
        <li className="dropdown-header">
          {title}
          {footerAction && (
            <a href="#">
              <span className="badge rounded-pill bg-primary p-2 ms-2">{footerAction.text}</span>
            </a>
          )}
        </li>
        <li>
          <hr className="dropdown-divider" />
        </li>
        {items.map((item, index) => (
          <React.Fragment key={index}>
            <li className={item.className}>
              <a href={item.link}>
                {item.icon && <i className={`bi ${item.icon}`}></i>}
                <div>
                  <h4>{item.title}</h4>
                  <p>{item.description}</p>
                  <p>{item.timestamp}</p>
                </div>
              </a>
            </li>
            <li>
              <hr className="dropdown-divider" />
            </li>
          </React.Fragment>
        ))}
        <li>
          <a className="dropdown-footer" href="#">
            {footerAction?.text || 'Show all'}
          </a>
        </li>
      </ul>
    </li>
  );
};

export default Dropdown;
